<ng-select 
           [items]="listValue$ | async"
           bindLabel="taxcode"
           autofocus
           bindValue="tax_code"
           [loading]="lookupLoading"
           [(ngModel)]="selectedCode"
           (change)="onOptionSelected($event)"
           placeholder="{{'placeholder.tax_code' | translate}}"
           [typeahead]="valueSubject$"
           typeToSearchText="{{'info.type_to_search_text' | translate}}"
           appendTo="body"
           (open)="onOpenDropdown()"
           (close)="onCloseDropdown()"
           (clear)="onTaxCodeClear()"
           >
           <ng-template ng-option-tmp let-item="item" let-clear="clear">
            {{item.tax_code}} <br/>
            <small>{{item.tax_description}}</small>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label text-base">{{item.tax_code}}</span>
                <span class="ng-value-icon right text-base" aria-hidden="true">×</span>
            </ng-template>
</ng-select>